module.exports = __webpack_public_path__ + "static/media/landing-desktop-1x.242a46dd.jpg";